module.exports = "/Public/build/1dd4fadf8e23b7d15b3c40e75060d9af.svg";


//////////////////
// WEBPACK FOOTER
// ./data/assets/marker-project-active.svg
// module id = 269
// module chunks = 0